import vue from "vue";
import dayjs from "dayjs";

vue.filter('readableTime', (value) => {
  const time = dayjs(value, 'HH:mm:ss');

  const min = time.format('m');
  const sec = time.format('s');

  const minuts = min !== '0' ? `${min}min` : '';
  const seconds = sec !== '0' ? `${sec}sec` : '';

  return `${minuts} ${seconds}`;
});